import { ResponseOptions } from "./response.options";

export class GetOptions {
  headers: Headers;
  response: ResponseOptions;
}
